import { layers } from '@jira/platform__ui-layers';
import type { UserPickerSelectStylesConfig } from './types.tsx';

export const defaultUserPickerStyles: UserPickerSelectStylesConfig = {
	menuPortal: (base) => ({
		...base,
		zIndex: String(layers.modal),
	}),
};
